import $ from 'jquery';

import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

class HeroSlider extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1,
            loop: true,
            modules: [Pagination, Autoplay, EffectFade],
            pagination: {
                el: '.hero-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        })

        swiper.on('slideChange', function (e) {
            $('.swiper-pagination-bullet-active').prevAll().addClass('prev')
            setTimeout(() => {
                $('.swiper-pagination-bullet').removeClass('prev')
            }, 5300)
        })
    }
}

customElements.define('hero-slider', HeroSlider)
